/**
 * @packageDocumentation
 * @module      EmcDataPoller.ts
 * @description Singleton - Encapsulates the logic for polling EMC data at regular intervals.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import CloudApi from "../CloudApi";
import Fetcher from "../Fetcher";
import EmcSystemCollection from "./EmcSystemCollection";
import EmcJsonToPacketConverter from "./EmcJsonToPacketConverter";
import EmcConsts from "./EmcConsts";
import ConsoleLogger from "../ConsoleLogger";
export default class EmcDataPoller {
    constructor() {
        this.alreadyIsIdleMonitorOn = false;
        this.interval = null;
        this.emcDataPollerFetcher = new Fetcher();
    }
    static getEmcDataPoller() {
        if (null == EmcDataPoller.emcDataPoller) {
            EmcDataPoller.emcDataPoller = new EmcDataPoller();
        }
        return EmcDataPoller.emcDataPoller;
    }
    poll() {
        this.worker = (() => {
            const setInterval = `
            setInterval(() => {
                postMessage("pollEmcServer");
            }, ${EmcConsts.POLLING_INTERVAL});
            `;
            const blob = new Blob([setInterval], { type: "application/javascript" });
            return new Worker(URL.createObjectURL(blob));
        })();
        this.worker.onmessage = (event) => {
            if (event.data == "pollEmcServer") {
                let activeSystemIds = EmcSystemCollection.getActiveSystemIds();
                let emcSignalsSystemMap = new Map();
                let isIdleMonitorOn = false;
                activeSystemIds.forEach(systemId => {
                    let emcSystem = EmcSystemCollection.getSystem(systemId);
                    if (undefined != emcSystem) {
                        isIdleMonitorOn = emcSystem.emcSignals.EmcMode;
                        emcSignalsSystemMap.set(systemId.toString(), emcSystem.emcSignals);
                    }
                });
                if (true == isIdleMonitorOn) {
                    ConsoleLogger.log("Idle monitor is running");
                    new CloudApi(this.emcDataPollerFetcher).getEmcTestData(emcSignalsSystemMap).then((response) => {
                        ConsoleLogger.log("Data coming to the frontend is ", response);
                        EmcJsonToPacketConverter.processJson(response);
                    });
                }
                // Data stopped just now, so call stop emc logs.
                else if (true == this.alreadyIsIdleMonitorOn && false == isIdleMonitorOn) {
                    this.stopEMCLogs();
                }
                this.alreadyIsIdleMonitorOn = isIdleMonitorOn;
            }
        };
    }
    stopEMCLogs() {
        let activeSystemIds = EmcSystemCollection.getActiveSystemIds();
        activeSystemIds.forEach(systemId => {
            EmcSystemCollection.removeSystem(systemId);
            new CloudApi(this.emcDataPollerFetcher).stopEMCLog(systemId).then((result) => { });
        });
    }
}
//# sourceMappingURL=EmcDataPoller.js.map